import React from 'react';
import { ConditionsPanel } from './components/conditions/ConditionsPanel';
export function App() {
  return <main className="min-h-screen w-full bg-[#F3F3F3] px-2 py-4 font-sans text-slate-900 md:px-3" data-id="element-0" data-mp="35babffqtzqba">
      <div className="w-full" data-id="element-1" data-mp="3k8jgtdcyyum0">
        <ConditionsPanel data-id="element-2" data-mp="3k8t7721xf3s8" />
      </div>
    </main>;
}